import MDrawer from './src';
import './style';

MDrawer.install = Vue => {
  Vue.component('MDrawer', MDrawer);
};

export default MDrawer;
